/* unplugin-vue-components disabled */import { render } from "./BaseIdentify.vue?vue&type=template&id=3b14c1ac"
import script from "./BaseIdentify.vue?vue&type=script&lang=js"
export * from "./BaseIdentify.vue?vue&type=script&lang=js"
script.render = render

export default script